<template>
  <div ref="container" style="padding:0 24px;height: 100%;">
    <el-descriptions ref="desc" size="mini" :inline="true" :colon="false" :model="yt.conditions" class="demo-form-inline" :size="100">
      <el-descriptions-item :label="$t('mujubianhao')">
        {{ $attrs.mouldEquipment.no }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('mujumingcheng')">
        {{ $attrs.mouldEquipment.name }}
      </el-descriptions-item>
    </el-descriptions>
    <el-tabs ref="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('chanpin')" name="first"> </el-tab-pane>
      <el-tab-pane :label="$t('shipeishebei')" name="second"> </el-tab-pane>
      <el-tab-pane :label="$t('shipeidunwei')" name="third"> </el-tab-pane>
      <el-tab-pane :label="$t('xiangjian')" name="fourth"> </el-tab-pane>
    </el-tabs>
    <div :style="{ height: tableHeight + 'px' }">
      <mould_equipment_product :mouldEquipment="$attrs.mouldEquipment" v-show="activeName == 'first'" v-if="tableHeight != 0"></mould_equipment_product>
      <mould_equipment :mouldEquipment="$attrs.mouldEquipment" v-show="activeName == 'second'" v-if="tableHeight != 0"></mould_equipment>
      <mould_equipment_tonnage :mouldEquipment="$attrs.mouldEquipment" v-show="activeName == 'third'" v-if="tableHeight != 0"></mould_equipment_tonnage>
      <mould_equipment_insert :mouldEquipment="$attrs.mouldEquipment" v-show="activeName == 'fourth'" v-if="tableHeight != 0"></mould_equipment_insert>
    </div>
  </div>
</template>

<script>
import mould_equipment from "@@/pages/web/base/mould/mould_equipment";
import mould_equipment_product from "@@/pages/web/base/mould/mould_equipment_product";
import mould_equipment_tonnage from "@@/pages/web/base/mould/mould_equipment_tonnage";
import mould_equipment_insert from "@@/pages/web/base/mould/mould_equipment_insert";
export default {
  name: "web_base_mould_mould_equipment_index",
  components: {
    mould_equipment,
    mould_equipment_product,
    mould_equipment_tonnage,
    mould_equipment_insert,
  },
  data() {
    return {
      activeName: "first",
      tableHeight: 0,
    };
  },
  created() {},

  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },

  methods: {
    resize() {
      this.$nextTick(() => {
        this.tableHeight = this.$refs.container.offsetHeight - 40 - 33 - 14;
      });
    },
    handleClick(tab) {
      this.utils.event_hub.$emit("RESIZE");
    },
  },
};
</script>

<style></style>
